import jwtDecode from "jwt-decode";
import * as R from "ramda";

import { LOGIN, SIGNUP } from "../actions/session";
import { consumeImpersonationToken } from "../../utils/impersonationToken";

const buildInitialState = token => {
  if (!token) return {};

  try {
    return R.pipe(
      token => jwtDecode(token),
      R.prop("data"),
      R.applySpec({
        company: R.prop("idCompany"),
        roles: R.prop("roles"),
        token: R.always(token)
      })
    )(token);
  } catch (_error) {
    localStorage.removeItem("token");
    return {};
  }
};

const token = consumeImpersonationToken() || localStorage.getItem("token");

export const initialState = buildInitialState(token);

const session = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case SIGNUP.RESOLVED:
      return {
        ...state,
        token: payload.token,
        user: payload.user
      };
    case LOGIN.RESOLVED:
      return {
        ...state,
        token: payload.token,
        company: payload.idCompany,
        roles: payload.roles
      };
    default:
      return state;
  }
};

export default session;
